<template>
  <v-card flat border>
    <v-toolbar color="secondary" flat density="compact">
      <v-toolbar-title>
        <v-icon class="text-accent mr-4">mdi-folder-information-outline</v-icon>
        <span class="text-accent text-h6 text-uppercase">{{
          title
        }}</span></v-toolbar-title
      >
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="py-2" v-for="item in info"
        :key="item.parameterId">
        <v-text-field
            :label="item.description"
            :model-value="item.value"
            variant="underlined"
            persistent-hint
            readonly
          ></v-text-field>
      </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "InfoBox",
  props: ["title", "info"],
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
</style>
